import Loading from '../../../../templates/UI/Loading/Loading'
import { Modal, Form, Button } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import callAPI from '../../../../helpers/callAPI'
import CustomButton from '../../../../templates/UI/CustomButton/CustomButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip'
import { useAuth } from '../../../../context/AuthContext'

const TrackingModal = ({ showSystemMessage, isOpen, setIsOpen, data, setData, dataLoaded, isCreate, setIsCreate, id, refetch }) => {
    const [formData, setFormData] = useState({ platform_name: '', supports_multiple_postback: 'N', api_tracking: 'N', allows_safesearch: 'N', safesearch_certified: 'N', safesearch_enable_param: '', safesearch_enable_value: '', safesearch_url_param: '' })

    const [submitting, setSubmitting] = useState(false)
    const [deleting, setDeleting] = useState(false)

    const auth = useAuth()
    const manager = auth.user

    const platformId = !isCreate && data?.platformsList && data.platformsList[id] ? parseInt(data.platformsList[id].platform_id) : 0
    const [platformLogins, setPlatformLogins] = useState([])
    const [platformLoginsLoaded, setPlatformLoginsLoaded] = useState(false)

    const [loginModalOpen, setLoginModalOpen] = useState(false)
    const [isLoginCreate, setIsLoginCreate] = useState(true)
    const [loginFormData, setLoginFormData] = useState({ url: '', login: '', password: '', notes: '' })
    const [editingLoginRowId, setEditingLoginRowId] = useState(null)
    const [loginSubmitting, setLoginSubmitting] = useState(false)

    const getUrl = (url) => {
        let formattedURL = url.substring(0, 4) === 'http' ? url : url.substring(0, 5) === 'https' ? url : `http://${url}`
        return formattedURL
    }

    const fetchPlatformLogins = async () => {
        if (!platformId || Number.isNaN(platformId)) return

        setPlatformLoginsLoaded(false)
        const result = await callAPI(`advertisers/platforms/${platformId}/logindetails`, 'GET', {}, false)
        if (result.success) {
            setPlatformLogins(result.loginDetails || [])
            setPlatformLoginsLoaded(true)
        } else {
            showSystemMessage('error', result.errors?.message || result.message || 'Failed to fetch platform login details')
            setPlatformLogins([])
            setPlatformLoginsLoaded(true)
        }
    }

    useEffect(() => {
        if (!isOpen || isCreate) return
        if (!platformId) return
        if (!dataLoaded) return
        fetchPlatformLogins()
    }, [isOpen, isCreate, platformId, dataLoaded])

    const createTracking = async (e) => {

        e.preventDefault()

        if (formData.safesearch_certified === 'Y' && (formData.safesearch_enable_param === '' || formData.safesearch_enable_value === '' || formData.safesearch_url_param === '')) {
            showSystemMessage('error', 'Please fill in all required SafeSearch fields.')
            return
        }

        setSubmitting(true)
        const result = await callAPI('advertisers/platformsList', 'POST', isCreate ? formData : data.platformsList[id])
        if (result.success) {
            refetch()
            showSystemMessage('success', 'Tracking created successfully')
            setFormData({ platform_name: '', supports_multiple_postback: '', api_tracking: '' })
            setIsOpen(false)
        } else {
            showSystemMessage('error', result.errors.message)
            setSubmitting(false)
        }
    }

    const updateTracking = async (e) => {
        e.preventDefault()

        if (data.platformsList[id].safesearch_certified === 'Y' && (data.platformsList[id].safesearch_url_param === '')) {
            showSystemMessage('error', 'SafeSearch URL parameter is required.')
            return
        }
        setSubmitting(true)

        const result = await callAPI('advertisers/platformsList', 'PUT', data.platformsList[id])
        if (result.success) {
            refetch()
            showSystemMessage('success', 'Tracking updated successfully')
            setIsOpen(false)
        } else {
            showSystemMessage('error', result.errors.message)
            setSubmitting(false)
        }
    }

    const deleteTracking = async (e) => {

        e.preventDefault()
        // Why is it checking for fields while deleting?
        // if (data.platformsList[id].safesearch_certified === 'Y' && (data.platformsList[id].safesearch_enable_param === '' || data.platformsList[id].safesearch_enable_value === '' || data.platformsList[id].safesearch_url_param === '')) {
        //     showSystemMessage('error', 'Please fill in all required SafeSearch fields.')
        //     return
        // }

        setDeleting(true)
        const result = await callAPI('advertisers/platformsList', 'DELETE', data.platformsList[id])
        if (result.success) {
            setIsCreate(true)
            refetch()
            showSystemMessage('success', 'Tracking deleted successfully')
            setIsOpen(false)
        } else {
            showSystemMessage('error', result.errors.message)
            setDeleting(false)
        }
    }

    const openCreatePlatformLogin = () => {
        setIsLoginCreate(true)
        setEditingLoginRowId(null)
        setLoginFormData({ url: '', login: '', password: '', notes: '' })
        setLoginModalOpen(true)
    }

    const openEditPlatformLogin = (row) => {
        setIsLoginCreate(false)
        setEditingLoginRowId(row.id)
        setLoginFormData({
            url: row.url || '',
            login: row.login || '',
            password: row.password || '',
            notes: row.notes || '',
        })
        setLoginModalOpen(true)
    }

    const createPlatformLogin = async () => {
        if (!platformId) return
        setLoginSubmitting(true)
        const result = await callAPI(`advertisers/platforms/${platformId}/logindetails`, 'POST', { ...loginFormData, manager })
        if (result.success) {
            setLoginModalOpen(false)
            setLoginSubmitting(false)
            showSystemMessage('success', 'Platform login created successfully')
            fetchPlatformLogins()
        } else {
            showSystemMessage('error', result.errors?.message || result.message || 'Failed to create platform login')
            setLoginSubmitting(false)
        }
    }

    const updatePlatformLogin = async () => {
        if (!platformId) return
        setLoginSubmitting(true)
        const result = await callAPI(`advertisers/platforms/${platformId}/logindetails`, 'PUT', { ...loginFormData, manager, id: editingLoginRowId })
        if (result.success) {
            setLoginModalOpen(false)
            setLoginSubmitting(false)
            showSystemMessage('success', 'Platform login updated successfully')
            fetchPlatformLogins()
        } else {
            showSystemMessage('error', result.errors?.message || result.message || 'Failed to update platform login')
            setLoginSubmitting(false)
        }
    }

    const deletePlatformLogin = async (row) => {
        if (!platformId) return
        setLoginSubmitting(true)
        const result = await callAPI(`advertisers/platforms/${platformId}/logindetails`, 'DELETE', { id: row.id })
        if (result.success) {
            setLoginSubmitting(false)
            showSystemMessage('success', 'Platform login deleted successfully')
            fetchPlatformLogins()
        } else {
            showSystemMessage('error', result.errors?.message || result.message || 'Failed to delete platform login')
            setLoginSubmitting(false)
        }
    }

    return (
        <>
            <Modal show={isOpen} onHide={() => setIsOpen(false)}>
                <form onSubmit={isCreate ? createTracking : updateTracking}>
                    <Modal.Header closeButton>
                        <Modal.Title>{isCreate ? 'Create' : 'Edit'} Advertiser Platform</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {dataLoaded ? (
                            <>
                                <ReactTooltip />                                
                                <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                    <span style={{ width: '30%' }}>Platform Name: </span>
                                    <div className="w-75">
                                        <Form.Control type="text" value={isCreate ? formData.platform_name : data.platformsList[id].platform_name} onChange={(e) => (isCreate ? setFormData({ ...formData, platform_name: e.target.value }) : setData({ platform_name: e.target.value }))} />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                    <span style={{ width: '30%' }}>Multiple Postbacks: </span>
                                    <div className="w-75">
                                        <Form.Control as="select" onChange={(e) => (isCreate ? setFormData({ ...formData, supports_multiple_postback: e.target.value }) : setData({ supports_multiple_postback: e.target.value }))} value={isCreate ? formData.supports_multiple_postback : data.platformsList[id].supports_multiple_postback}>
                                            <option value="Y">Yes</option>
                                            <option value="N">No</option>
                                        </Form.Control>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                    <span style={{ width: '30%' }}>API Tracking: </span>
                                    <div className="w-75">
                                        <Form.Control as="select" onChange={(e) => (isCreate ? setFormData({ ...formData, api_tracking: e.target.value }) : setData({ api_tracking: e.target.value }))} value={isCreate ? formData.api_tracking : data.platformsList[id].api_tracking}>
                                            <option value="Y">Yes</option>
                                            <option value="N">No</option>
                                        </Form.Control>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                    <span style={{ width: '30%' }}>Allows SafeSearch: </span>
                                    <div className="w-75 d-flex align-items-center">
                                        <Form.Control as="select" onChange={(e) => (isCreate ? setFormData({ ...formData, allows_safesearch: e.target.value }) : setData({ allows_safesearch: e.target.value }))} value={isCreate ? formData.allows_safesearch : data.platformsList[id].allows_safesearch ? data.platformsList[id].allows_safesearch : 'N'}>
                                            <option value="Y">Yes</option>
                                            <option value="N">No</option>
                                        </Form.Control>
                                        <FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={"Enabling this setting means that affiliates will be able to pull a safsearch link for this platform."} />
                                    </div>
                                </div>
                                {
                                    (isCreate ? formData.allows_safesearch === 'Y' : data.platformsList[id].allows_safesearch === 'Y') ? (
                                        <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                            <span style={{ width: '30%' }}>SafeSearch Certified: </span>
                                            <div className="w-75 d-flex align-items-center">
                                                <Form.Control as="select" onChange={(e) => (isCreate ? setFormData({ ...formData, safesearch_certified: e.target.value }) : setData({ safesearch_certified: e.target.value }))} value={isCreate ? formData.safesearch_certified : data.platformsList[id].safesearch_certified ? data.platformsList[id].safesearch_certified : 'N'}>
                                                    <option value="Y">Yes</option>
                                                    <option value="N">No</option>
                                                </Form.Control>
                                                <FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={"Enable this setting if the platform is SafeSearch certified."} />
                                            </div>
                                        </div>
                                    ) : null                                
                                }
                                {
                                    (isCreate ? formData.safesearch_certified === 'Y' : data.platformsList[id].safesearch_certified === 'Y') ? (
                                        <>
                                            <div className="d-flex justify-content-end align-items-center w-100 mb-2">
                                                <span style={{ width: '30%' }}></span>
                                                <div className="w-75 d-flex align-items-center text-left">
                                                    <div>
                                                        <a href='https://support.google.com/google-ads/answer/13707634?hl=en#:~:text=MaxBounty' target="_blank" rel="noopener noreferrer">
                                                            <FontAwesomeIcon className="ml-2 text-primary" icon={faExternalLinkAlt} /> Google Certified Trackers
                                                        </a>
                                                        <p>The below parameters will be appended to the landing pages for all applicable campaigns. They are required to ensure that our landing pages are also compliant with Google's Transparency rules.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                                <span style={{ width: '30%' }}>SafeSearch Key/value: </span>
                                                <div className="w-75 d-flex align-items-center">
                                                    &<Form.Control type="text" value={isCreate ? formData.safesearch_enable_param : data.platformsList[id].safesearch_enable_param} onChange={(e) => (isCreate ? setFormData({ ...formData, safesearch_enable_param: e.target.value }) : setData({ safesearch_enable_param: e.target.value }))} />
                                                    =<Form.Control type="text" value={isCreate ? formData.safesearch_enable_value : data.platformsList[id].safesearch_enable_value} onChange={(e) => (isCreate ? setFormData({ ...formData, safesearch_enable_value: e.target.value }) : setData({ safesearch_enable_value: e.target.value }))} />
                                                    <FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={"key/value this platform uses with Google to indicate that it is a SafeSearch url. May be Optional."} />
                                                </div>
                                            </div>                                        
                                            <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                                                <span style={{ width: '30%' }}>SafeSearch URL Param: </span>
                                                <div className="w-75 d-flex align-items-center">
                                                    &<Form.Control type="text" value={isCreate ? formData.safesearch_url_param : data.platformsList[id].safesearch_url_param} onChange={(e) => (isCreate ? setFormData({ ...formData, safesearch_url_param: e.target.value }) : setData({ safesearch_url_param: e.target.value }))} required={formData.allows_safesearch === 'Y' && formData.safesearch_certified === 'Y'} />
                                                    =[landing_page_setting_url]
                                                    <FontAwesomeIcon className="ml-2 text-primary" icon={"question-circle"} data-tip={"The value for this parameter is set at the individual landing page."} />
                                                </div>
                                            </div>
                                        </>                                    
                                    ) : null
                                }
                            {!isCreate && (
                                <>
                                    <hr />
                                    <div className="border rounded p-2 mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div>
                                                <div className="font-weight-bold">Platform Level Logins</div>
                                            </div>
                                            <Button variant="warning" size="sm" onClick={openCreatePlatformLogin}>
                                                Add Login
                                            </Button>
                                        </div>
                                        {platformLoginsLoaded ? (
                                            platformLogins.length === 0 ? (
                                                <div>No Platform Logins Available</div>
                                            ) : (
                                                platformLogins.map((row) => (
                                                    <div key={row.id} className="bg-light d-flex p-2 mb-2 rounded">
                                                        <div className="d-flex flex-column w-100">
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <div>
                                                                    <div>
                                                                        Site: <a target="_blank" rel="noopener noreferrer" href={getUrl(row.url)}>{row.url}</a>
                                                                    </div>
                                                                    <div>Login: {row.login}</div>
                                                                    <div>Notes: {row.notes}</div>
                                                                </div>
                                                                <div className="d-flex align-items-center">
                                                                    <Button
                                                                        variant="warning"
                                                                        size="sm"
                                                                        className="mr-2"
                                                                        onClick={() => openEditPlatformLogin(row)}
                                                                    >
                                                                        Edit
                                                                    </Button>
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => deletePlatformLogin(row)}
                                                                        disabled={loginSubmitting}
                                                                    >
                                                                        Delete
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )
                                        ) : (
                                            <Loading />
                                        )}
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        <td>
                            <Loading />
                        </td>
                    )}
                    </Modal.Body>
                    <Modal.Footer>
                        {isCreate ? (
                            <CustomButton variant="primary" type="submit" name="Create" spin={submitting} />
                        ) : (
                            <>
                                <CustomButton variant="primary" type="submit" name="Update" spin={submitting} />
                                <CustomButton variant="danger" name="Delete" onClick={deleteTracking} spin={deleting} type="button" />
                            </>
                        )}
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={loginModalOpen} onHide={() => setLoginModalOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoginCreate ? 'Add Platform Login' : 'Edit Platform Login'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex align-items-center mb-2">
                        <span className="w-25">Login URL:</span>
                        <Form.Control
                            type="text"
                            value={loginFormData.url}
                            onChange={(e) => setLoginFormData({ ...loginFormData, url: e.target.value })}
                        />
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <span className="w-25">Username/ email:</span>
                        <Form.Control
                            type="text"
                            value={loginFormData.login}
                            onChange={(e) => setLoginFormData({ ...loginFormData, login: e.target.value })}
                        />
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <span className="w-25">Password:</span>
                        <Form.Control
                            type="text"
                            value={loginFormData.password}
                            onChange={(e) => setLoginFormData({ ...loginFormData, password: e.target.value })}
                        />
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <span className="w-25">Notes:</span>
                        <Form.Control
                            type="text"
                            value={loginFormData.notes}
                            onChange={(e) => setLoginFormData({ ...loginFormData, notes: e.target.value })}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" disabled={loginSubmitting} onClick={isLoginCreate ? createPlatformLogin : updatePlatformLogin}>
                        {isLoginCreate ? 'Create Login' : 'Update Login'}
                    </Button>
                    <Button variant="secondary" disabled={loginSubmitting} onClick={() => setLoginModalOpen(false)} className="ml-2">
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default TrackingModal

